import states from '../states';
import IDConfig from './qleDocumentConfigID';
import PAConfig from './qleDocumentConfigPA';
import NVConfig from './qleDocumentConfigNV';
import NJConfig from './qleDocumentConfigNJ';
import VAConfig from './qleDocumentConfigVA';
import GAConfig from './qleDocumentConfigGA';
import ILConfig from './qleDocumentConfigIL';
import MNConfig from './qleDocumentConfigMN';
import NMConfig from './qleDocumentConfigNM';

interface IStateConfig {
    events: string[];
    documents: {
        categoryType: string;
        documentsQty: number;
        documentTypes: string[];
        mandatoryDocuments?: string[];
    }[];
}

const createConfig = (stateEventsConfig: IStateConfig[]) => {
    const config = new Map();

    stateEventsConfig.forEach(stateConfig => {
        config.set(stateConfig.events, { documents: stateConfig.documents });
    });

    return config;
};

export const documentsVerificationConfig = {
    [states.IDAHO]: createConfig(IDConfig),
    [states.PENNSYLVANIA]: createConfig(PAConfig),
    [states.NEVADA]: createConfig(NVConfig),
    [states.NEW_JERSEY]: createConfig(NJConfig),
    [states.VIRGINIA]: createConfig(VAConfig),
    [states.GEORGIA]: createConfig(GAConfig),
    [states.ILLINOIS]: createConfig(ILConfig),
    [states.MINNESOTA]: createConfig(MNConfig),
    [states.NEW_MEXICO]: createConfig(NMConfig),
};
